import React, { useContext, useCallback } from 'react';
import { IModifierGroupContext, ModifierGroupContext } from '../modifierGroupState/modifierGroupContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalSelectCustomer } from 'components/ModalWindows/ModalSelectCustomer';
import { ModalAssignModifierGroupToRestaurants } from 'components/ModalWindows/ModalAssignModifierGroupToRestaurants';
import { ModalEditModifierTemplate } from 'components/ModalWindows/ModalEditModifierTemplate';

export const ModalWindows: React.FC = () => {
	const {
		refetchData,
		deleteSelectedItem,
		changeTypeOfModalWindow,
		setIDCustomer,
		toggleRememberMyChoice,
		rememberMyChoice,
		typeOfModalWindow,
		IDSelectedCustomer,
		IDForAssignRestaurants,
		IDForEditModifiersTemplate,
		isInitializedSelectCustomerModal,
	} = useContext<IModifierGroupContext>(ModifierGroupContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModal = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchData(true);
	}, [changeTypeOfModalWindow, refetchData]);

	const handleCloseWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingModifierGroup');
	}, [changeTypeOfModalWindow]);

	const handleCloseEditModifiersTemplateModal = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchData(true);
	}, [changeTypeOfModalWindow, refetchData]);

	const handleCloseModGroupHasPortionsError = useCallback(() => {
		changeTypeOfModalWindow('errorModGroupHasPortions');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !IDSelectedCustomer}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirm
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="deleteModifierGroup"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="deleteModifierGroupSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorWhileDeletingModifierGroup"
				/>
			)}
			{typeOfModalWindow === 'errorUpdatingModifierGroup' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingModifierGroup"
				/>
			)}
			{typeOfModalWindow === 'errorModGroupHasPortions' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorModGroupHasPortions"
				/>
			)}
			{!IDSelectedCustomer && isInitializedSelectCustomerModal && (
				<ModalSelectCustomer
					setIDCustomer={setIDCustomer}
					toggleRememberMyChoice={toggleRememberMyChoice}
					rememberMyChoice={rememberMyChoice}
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && IDForAssignRestaurants && (
				<ModalAssignModifierGroupToRestaurants
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseAssignRestaurantsModal}
					onShowError={handleCloseWithError}
					modifierGroupId={IDForAssignRestaurants}
				/>
			)}
			{/* TODO: Implement Edit Restaurant Properties modal */}
			{typeOfModalWindow === 'editModifiersTemplate' && IDForEditModifiersTemplate && IDSelectedCustomer && (
				<ModalEditModifierTemplate
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseEditModifiersTemplateModal}
					onShowError={handleCloseWithError}
					onShowProductHasPortionsError={handleCloseModGroupHasPortionsError}
					modifierGroupId={IDForEditModifiersTemplate}
					customerId={IDSelectedCustomer}
				/>
			)}
		</ModalWrapper>
	);
};
